var App = App || {};

App.ModalCtas = (function ($) {
    'use strict';

    function bindTriggers() {
        $(document).on("click", ".trigger-modal", function () {
            const key = $(this).data("cta-key");
            const $modal = $("#myModal");

            if (key && $modal.length) {
                $modal.data("ctaKey", key.trim().toLowerCase());
                $modal.data("triggerElement", this);
            }
        });
    }

    function handleModalShow() {
        $(document).on("show.bs.modal", "#myModal", function (e) {
            const $modal = $(this);
            const trigger = e.relatedTarget || $modal.data("triggerElement");
            const $trigger = $(trigger);

            const key = ($trigger.data("cta-key") || "").trim().toLowerCase();
            const ctas = window.modalCtas || [];

            const matched = ctas.filter(item => {
                const classParts = (item.Class || "")
                    .toLowerCase()
                    .split(/[,\/|]+/)
                    .map(p => p.trim());

                const labelKey = (item.Label || "").trim().toLowerCase();
                return classParts.includes(key) || labelKey === key;
            });

            // Cancel modal if nothing matches
            if (matched.length === 0) {
                e.preventDefault();
                return;
            }

            const $body = $modal.find(".modal-body");
            const $ctas = $body.find(".ctas");
            const $title = $body.find(".modal-title");

            $ctas.empty();
            $title.text("");

            const firstMatch = matched[0];
            let modalTitle = firstMatch.Modaltitle || "";

            // Determine unmatched class parts to show in title
            const classParts = (firstMatch.Class || "")
                .split(/[,\/|]+/)
                .map(p => p.trim())
                .filter(Boolean);

            if (classParts.length > 1) {
                modalTitle = classParts[1];
            }
         
            $title.text(modalTitle);

            // Render matched CTAs
            matched.forEach(item => {
                const $a = $(`
                    <a href="${item.Url || "#"}"
                       target="${item.Target || "_self"}"
                       aria-label="${item.Aria || ""}"
                       class="cta ${item.Class || ''}">
                        <span class="icon"><i class="${item.Modalicon || item.Icon || ''}"></i></span>
                        <span class="text">${item.Label || ''}</span>
                        <span class="fa fa-lower-chevron fa-chevron-right"></span>
                    </a>
                `);
                $ctas.append($a);
            });

            // Clean up after show
            $modal.removeData("ctaKey");
            $modal.removeData("triggerElement");
        });
    }

    function init() {
        bindTriggers();
        handleModalShow();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ModalCtas.init();
});
